import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { SizeTable } from './table';

interface TableData {
  headers: Array<
    Array<{
      content: string;
      colSpan?: number;
      rowSpan?: number;
    }>
  >;
  data: Array<
    Array<{
      content: string;
      colSpan?: number;
      rowSpan?: number;
    }>
  >;
}

interface SizeGuideSectionProps {
  title: string;
  tableData: TableData;
  className?: string;
}

export const SizeGuideSection = ({
  title,
  tableData,
  className = 'border-b-1 border-[#E0E0E0] w-full',
}: SizeGuideSectionProps) => {
  return (
    <Accordion
      type='single'
      collapsible
      className={className}
    >
      <AccordionItem
        value='item-1'
        className='border-transparent'
      >
        <AccordionTrigger
          className='py-[20px] font-roboto-regular text-[18px] leading-[30px]'
          iconClassName='w-[26px] h-[26px]'
        >
          {title}
        </AccordionTrigger>
        <AccordionContent className='pb-[40px] pt-0'>
          <SizeTable
            headers={tableData.headers}
            data={tableData.data}
          />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
